import { AppToast } from "@shared/ui";
import React, { ReactNode } from "react";
import { SettingsLayout } from "@medentic/polaris-react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { SettingsFilledIcon } from "@medentic/polaris-icons";
import { PageFooter } from "@shared/ui";
import { useGetSingleCompanyDetails } from "@shared/hooks/common/useGetSingleCompanyDetails";
import { ROOTS } from "@app/config/constants";
import { getSettingsNavigationItems } from "@features/clinics/utils";
import { getEventSettingsNavigationItems } from "@features/events/navigation";
import { EntityType } from "@shared/types/commonTypes";

interface SettingsPageWrapperProps {
  children: ReactNode;
  entityType: EntityType;
  entityId: string;
}

const SettingsPageWrapper: React.FC<SettingsPageWrapperProps> = ({
  children,
  entityType,
  entityId,
}) => {
  if (import.meta.env.DEV) {
    console.debug("[SettingsPageWrapper::SettingsPageWrapper]");
  }
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const rootPath =
    entityType === EntityType.CLINIC ? ROOTS.CLINIC : ROOTS.EVENTS;
  const settingsNavigationItems =
    entityType === EntityType.CLINIC
      ? getSettingsNavigationItems(t, entityId, location.pathname)
      : getEventSettingsNavigationItems(t, entityId, location.pathname);

  // Get company data using the hook (available for future use)
  useGetSingleCompanyDetails(entityId, {
    refetchOnMount: false,
  });

  const closeSettings = () => {
    navigate(`${rootPath}/${entityId}`);
  };

  return (
    <SettingsLayout
      title={t("companySettings.settingsTitle")}
      titleIcon={SettingsFilledIcon}
      navigationItems={settingsNavigationItems}
      onBack={closeSettings}
      onClose={closeSettings}
      beforeContent={<AppToast />}
      footer={<PageFooter />}
    >
      {children}
    </SettingsLayout>
  );
};

export default SettingsPageWrapper;
